import request from '@/utils/request'
import store from '@/store'

const url = store.getters.getPostUrl;
export default {
	getWorkloadStatistics(params) {
		return request({
			url: url + '/workOrder/getWorkloadStatistics',
			method: 'get',
			params: params
		})
	},
	getHandlingTimeStatistics(params) {
		return request({
			url: url + '/workOrder/getHandlingTimeStatistics',
			method: 'get',
			params: params
		})
	},
	
	getHandlingTimeStatisticsAggregate(params) {
		return request({
			url: url + '/workOrder/getHandlingTimeStatisticsAggregate',
			method: 'get',
			params: params
		})
	},
	getProcessingTimeDistributionStatistics(params) {
		return request({
			url: url + '/workOrder/getProcessingTimeDistributionStatistics',
			method: 'get',
			params: params
		})
	},
	getWorkloadStatisticsList(params) {
		return request({
			url: url + '/workOrder/getWorkloadStatisticsList',
			method: 'get',
			params: params
		})
	},
	getHandlingTimeStatisticsList(params) {
		return request({
			url: url + '/workOrder/getHandlingTimeStatisticsList',
			method: 'get',
			params: params
		})
	},
	getProcessingTimeDistributionStatisticsList(params) {
		return request({
			url: url + '/workOrder/getProcessingTimeDistributionStatisticsList',
			method: 'get',
			params: params
		})
	},
	getFaultStatistics(params) {
		return request({
			url: url + '/workOrder/getFaultStatistics',
			method: 'get',
			params: params
		})
	},
	getTimeQuantumStatistics(params) {
		return request({
			url: url + '/workOrder/getTimeQuantumStatistics',
			method: 'get',
			params: params
		})
	},
	getCustomerName() {
		return request({
			url: url + '/workOrder/getCustomerName',
			method: 'get',
		})
	},
	getaddr() {
		return request({
			url: url + '/workOrder/getaddr',
			method: 'get',
		})
	},
	getRank() {
		return request({
			url: url + '/workOrder/getRank',
			method: 'get',
		})
	},
}



// WEBPACK FOOTER //
// ./src/assets/js/sticList/stic.js